import { AppData, Lightning, Log } from '@lightningjs/sdk'
import { AppSetup } from '../lib/app-setup';

export interface CCItemContentTemplateSpec extends Lightning.Component.TemplateSpecLoose {

}

const controlsTextColor = 0xffffffff;
const controlsTextColorFocus = 0xffffffff;
const controlsTextColorSelected = 0xffff0000;
const controlsBGColorSelected = 0xffffffff;
const controlsBGColorFocus = 0xffff0000;
const controlsBGColor = 0x00000000;


export default class CCItemContent
  extends Lightning.Component<CCItemContentTemplateSpec>
  implements Lightning.Component<CCItemContentTemplateSpec> {
  selected = false
  content = ''
  itemIndex = 0
  private _focusAnimation: Lightning.types.Animation | undefined = undefined
  static override _template(): Lightning.Component.Template<CCItemContentTemplateSpec> {
    return {
      w: (w: any) => w,
      h: (h: any) => h,
      rect: true,
      color: controlsBGColor,
      Label: {
        x: 20,
        y: (h: any) => h / 2 + 5,
        mountY: 0.5,
        text: {
          text: "",
          fontSize: 30,
          // fontFace: Helper.getFontFamily('Regular'),
          letterSpacing: 0.82,
        },
      }
    }
  }

  override _handleEnter() {
    this.fireAncestors('$optionSelected', this.itemIndex)
    return true
  }
  
  update() {
    const bgColor = this.hasFocus() ? controlsBGColorFocus : (this.selected ? controlsBGColorSelected : controlsBGColor)
    const textColor = this.hasFocus() ? controlsTextColorFocus : (this.selected ? controlsTextColorSelected : controlsTextColor)
    this.setSmooth('color', bgColor)
    this.tag('Label').setSmooth('text.textColor', textColor)
  }

  override _focus() {
    this.update()
  }

  override _unfocus() {
    this.update()
  }

  set itemSelected(itemSelected: any) {
    this.selected = itemSelected || false
    Log.info('CCItemContent itemSelected: ', this.selected)
    this.update()
  }

  set item(itemInfo: any) {
    Log.info('CCItemContent setItem: ', itemInfo.name)
    this.tag('Label').text.text = itemInfo.name
  }

}